import React from 'react';
import './App.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import HomePage from './pages/Home.page';
import MoviesPage from './pages/Movies.page';
import SeriesPage from './pages/Series.page';
import SeriesDetailPage from './pages/SeriesDetail.page';
import MoviePage from './pages/Movie.page';
import ProfilePage from './pages/Profile.page';
import SearchResultsPage from './pages/SearchResults.page';
import WatchPlayerPage from './pages/WatchPlayer.page';
import RemotePage from './pages/Remote.page';
import MovieProvider from './components/context/Movies.context';
import { AuthProvider } from './context/Auth.context';
import ErrorBoundary from './components/common/ErrorBoundary';
import TvNavigation from './components/common/TvNavigation';
import PointerScroll from './components/common/PointerScroll';
import RemoteNavBridge from './components/common/RemoteNavBridge';
import RemotePointerBridge from './components/common/RemotePointerBridge';
import RouteBroadcast from './components/RouteBroadcast';
import RemotePointerOverlay from './components/common/RemotePointerOverlay';
import MobileBottomNav from './components/MobileBottomNav/MobileBottomNav.component';
import TvCastReceiver from './components/common/TvCastReceiver.component';

function AppContent() {
  const location = useLocation();
  const isPlayer = location.pathname.startsWith('/watch');

  return (
    <ErrorBoundary>
      <MovieProvider>
        <TvNavigation />
        {/* TV browsers with a virtual pointer (JioSphere etc.): pointer scroll + hover focus */}
        <PointerScroll />
        {/* TV-only: pairs with the phone via 6-digit code, receives play commands */}
        <TvCastReceiver />
        {/* Receives phone D-pad nav from the /tv receiver iframe (cross-origin safe) */}
        <RemoteNavBridge />
        {/* Receives phone magic-pointer gestures and shows the virtual TV cursor */}
        <RemotePointerBridge />
        {/* Tells the TV receiver which route the app is showing */}
        <RouteBroadcast />
        <RemotePointerOverlay />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/movies" element={<MoviesPage />} />
          <Route path="/series" element={<SeriesPage />} />
          <Route path="/series/:id" element={<SeriesDetailPage />} />
          <Route path="/movie/:id" element={<MoviePage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/search" element={<SearchResultsPage />} />
          {/* Phone-as-TV-remote control pad */}
          <Route path="/remote" element={<RemotePage />} />
          {/* Full-screen EmbedMaster player */}
          <Route path="/watch/movie/:id" element={<WatchPlayerPage />} />
          <Route path="/watch/tv/:id/:season/:episode" element={<WatchPlayerPage />} />
          {/* Legacy redirect */}
          <Route path="/plays" element={<Navigate to="/series" replace />} />
          {/* Catch-all redirect to Home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        {/* Mobile bottom nav + content spacer — hidden on player page */}
        {!isPlayer && <MobileBottomNav />}
        {!isPlayer && <div className="h-16 md:hidden" />}
      </MovieProvider>
    </ErrorBoundary>
  );
}

function App() {
  const key = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;
  if (!key || !key.startsWith('pk_')) {
    // No Clerk key: the app still boots — AuthProvider runs in local mode
    // (device-only session). This keeps old Android TVs working too.
    console.warn('REACT_APP_CLERK_PUBLISHABLE_KEY missing — running in local mode.');
  }

  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
